<script lang="ts" setup>
import { ref } from "vue";

const props = withDefaults(
  defineProps<{
    enableShine: boolean;
  }>(),
  {
    enableShine: true,
  }
);
const color = ref(["#A07CFE", "#FE8FB5", "#FFBE7B"]);
</script>
<template>
  <div
    :class="{
      'p-[2px]': enableShine,
    }"
    class="relative place-items-center bg-base-100 overflow-hidden flex flex-col items-center justify-center"
  >
    <div
      v-if="enableShine"
      :style="{
        '--border-width': `2px`,
        '--border-radius': `6px`,
        '--shine-pulse-duration': `14s`,
        '--mask-linear-gradient': `linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)`,
        '--background-radial-gradient': `radial-gradient(transparent,transparent, ${
          color instanceof Array ? color.join(',') : color
        },transparent,transparent)`,
      }"
      class="before:bg-shine-size before:absolute before:inset-0 before:size-full before:rounded-[--border-radius] before:p-[--border-width] before:will-change-[background-position] before:content-[''] before:![-webkit-mask-composite:xor] before:![mask-composite:exclude] before:[background-image:--background-radial-gradient] before:[background-size:300%_300%] before:[mask:--mask-linear-gradient] motion-safe:before:animate-[shine-pulse_var(--shine-pulse-duration)_infinite_linear] aspect-[3/4]"
    ></div>
    <slot />
  </div>
</template>
